import { get as _get } from 'lodash';

import { PaginationActions, PaginationActionTypes } from './pagination.actions';
import { initialPaginationState, PaginationState } from './pagination.models';

export function reducer(state = initialPaginationState, action: PaginationActions) {
  switch (action.type) {
    case PaginationActionTypes.INITIALIZE_PAGINATION:
      const totalItems = _get(action, 'payload');
      return Object.assign({}, state, {
        totalItems: totalItems,
        totalPages: Math.ceil(totalItems / state.pageSize)
      });
    case PaginationActionTypes.SET_CURRENT_PAGE:
      return Object.assign({}, state, {
        currentPage: _get(action, 'payload.pageNum'),
        pageItems: _get(action, 'payload.pageItems')
      });
    default:
      return state;
  }
}

export const getTotalPages = (state: PaginationState) => state.totalPages;
export const getCurrentPage = (state: PaginationState) => state.currentPage;
export const getPageItems = (state: PaginationState) => state.pageItems;
